import { CanonicalLoad } from '@numeo/types-core'

/** Get origin location string from filter data */
export const getOriginLocation = (originLocation?: string): string => {
    try {
        if (originLocation?.trim()) {
            return originLocation.trim()
        }
        return ''
    } catch {
        return originLocation?.trim() || ''
    }
}

/** Open Google Maps route: origin filter → pickup → delivery */
export const openDeadheadRoute = (load: CanonicalLoad, event?: React.MouseEvent, originLocation?: string) => {
    if (event) {
        event.stopPropagation()
    }

    try {
        const originFilterLocation = getOriginLocation(originLocation)
        const pickupCity = load.pickupCity?.trim()
        const pickupState = load.pickupStateProv?.trim()
        const deliveryCity = load.deliveryCity?.trim()
        const deliveryState = load.deliveryStateProv?.trim()

        if (!pickupCity || !pickupState || !deliveryCity || !deliveryState) return

        const pickupStr = `${pickupCity}, ${pickupState}`
        const deliveryStr = `${deliveryCity}, ${deliveryState}`

        let googleMapsUrl: string
        if (originFilterLocation) {
            googleMapsUrl = `https://www.google.com/maps/dir/${encodeURIComponent(originFilterLocation)}/${encodeURIComponent(pickupStr)}/${encodeURIComponent(deliveryStr)}`
        } else {
            googleMapsUrl = `https://www.google.com/maps/dir/${encodeURIComponent(pickupStr)}/${encodeURIComponent(deliveryStr)}`
        }

        window.open(googleMapsUrl, '_blank', 'noopener,noreferrer')
    } catch (error) {
        console.error('Error opening Google Maps:', error)
    }
}

export const formatLocationString = (city: string, state: string): string => {
    return `${city}, ${state}`
}

export const createGoogleMapsUrl = (origin: string, destination: string, userLocation?: string): string => {
    if (userLocation) {
        return `https://www.google.com/maps/dir/${encodeURIComponent(userLocation)}/${encodeURIComponent(origin)}/${encodeURIComponent(destination)}`
    }
    return `https://www.google.com/maps/dir/${encodeURIComponent(origin)}/${encodeURIComponent(destination)}`
}

export const isLocationValid = (city?: string, state?: string): boolean => {
    return Boolean(city?.trim() && state?.trim())
}

export const isLocationDataValid = (location: Record<string, unknown> | null): boolean => {
    return Boolean(location && location.city && location.stateProv && location.latitude && location.longitude)
}

export const parseLocationFromUrl = (url: string): { city: string; state: string } | null => {
    try {
        const urlObj = new URL(url)
        const params = urlObj.searchParams
        const location = params.get('location')
        if (location) {
            const [city, state] = location.split(',').map((s) => s.trim())
            return { city, state }
        }
        return null
    } catch {
        return null
    }
}
